// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8c07a78a","455":"973b8647","977":"cdaa2b66"}[chunkId] + ".chunk.js";
};